import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { auth, db } from "../api/firebase"; // あなたのFirebase設定のパスを適切に設定してください
import { Button, CircularProgress, TextField } from "@mui/material";

function DdpForm() {
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasDdps, setHasDdps] = useState(false);

  useEffect(() => {
    const checkDdps = async () => {
      const userId = auth.currentUser ? auth.currentUser.uid : null;
      if (userId) {
        const q = query(collection(db, `users/${userId}/ddps`));
        const querySnapshot = await getDocs(q);
        setHasDdps(!querySnapshot.empty);
      }
    };

    checkDdps();
  }, []);

  const handleChange = (event) => {
    setInputText(event.target.value);
  };

  const handleOpenModal = (event) => {
    event.preventDefault();
    // ここにモーダルを開くためのロジックを追加
  };

  if (hasDdps) {
    return null; // DDPSがある場合は何も表示しない
  }

  return (
    <div className="bg-white border rounded-md mt-2 p-4 shadow-sm hover:shadow-lg cursor-pointer">
      <div className="font-bold text-lg">DDP設定</div>
      <form onSubmit={handleOpenModal}>
        <TextField
          multiline
          minRows={3}
          placeholder="あなたのDDPを登録してください。"
          variant="outlined"
          fullWidth
          value={inputText}
          onChange={handleChange}
          style={{ margin: "10px 0" }}
          disabled={loading}
          className="text"
        />
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={loading || !inputText}
        >
          送信
        </Button>
        {loading && <CircularProgress size={24} style={{ marginLeft: 15 }} />}
      </form>
    </div>
  );
}

export default DdpForm;
